function precise_round(num, decimals) {
    var sign = num >= 0 ? 1 : -1;
    return (Math.round((num*Math.pow(10,decimals)) + (sign*0.001)) / Math.pow(10,decimals)).toFixed(decimals);
}

function calcPercentages(values, percentages) {
    const nonzero = values.reduce((m, v) => {
        v !== 0 && m++;
        return m;
    }, 0);

    if (nonzero  === 0) { return percentages; }

    let result = [...percentages];
    for (let i=0; i<values.length; i++) {
        if (values[i] === 0) {
            result = result.map((v, j) => {
                if (i === j) { return v; }
                return v += percentages[i] / nonzero;
            });
        }
    }
    return result;
}

function calcGroup(values, percentages) {
    const calculatedPercentages = calcPercentages(values, percentages);
    const calculatedValues = values.map((v, i) => {
        return v * calculatedPercentages[i];
    });
    return calculatedValues.reduce((m, v) => {
        m += v;
        return m;
    }, 0) / 100;
}

function calculateStrategyScore(proposal) {
    const score = calcGroup([
        parseInt(proposal.Strategy1, 10) || 0,
        parseInt(proposal.Strategy2, 10) || 0,
        parseInt(proposal.Strategy3, 10) || 0,
        parseInt(proposal.Strategy4, 10) || 0,
        parseInt(proposal.Strategy5, 10) || 0,
    ],[
        20,
        20,
        20,
        20,
        20,
    ]);
    proposal.StrategyAverage = precise_round(score, 2);
}

function calculateBenefitScore(proposal) {
    const score = calcGroup([
        parseInt(proposal.Benefit1, 10) || 0,
        parseInt(proposal.Benefit2, 10) || 0,
        parseInt(proposal.Benefit3, 10) || 0,
        parseInt(proposal.Benefit4, 10) || 0,
    ],[
        14,
        31,
        39,
        16,
    ]);
    proposal.BenefitAverage = precise_round(score, 2);
}

function calculateScopeScore(proposal) {
    const score = calcGroup([
        parseFloat(proposal.Scope1)   || 0,
        parseInt(proposal.Scope2, 10) || 0,
        parseFloat(proposal.Scope3)   || 0,
        parseInt(proposal.Scope4, 10) || 0,
    ],[
        18,
        52,
        10,
        20,
    ]);
    proposal.ScopeAverage = precise_round(score, 2);
}

function calculateRiskScore(proposal) {
    const score = calcGroup([
        parseInt(proposal.Risk1, 10) || 0,
        parseInt(proposal.Risk2, 10) || 0,
        parseInt(proposal.Risk3, 10) || 0,
        parseInt(proposal.Risk4, 10) || 0,
    ],[
        9,
        51,
        21,
        19,
    ]);
    proposal.RiskAverage = precise_round(score, 2);
}

export function calculateAverages(proposal) {
    calculateStrategyScore(proposal);
    calculateBenefitScore(proposal);
    calculateScopeScore(proposal);
    calculateRiskScore(proposal);

    const score = calcGroup([
        parseFloat(proposal.StrategyAverage) || 0,
        parseFloat(proposal.BenefitAverage) || 0,
        parseFloat(proposal.ScopeAverage) || 0,
        parseFloat(proposal.RiskAverage) || 0,
    ],[
        16,
        50,
        26,
        8,
    ]);
    proposal.AverageScore = precise_round(score, 2);
}



// WEBPACK FOOTER //
// ./src/utils/calc.js